<template>
  <main id="main">
    <div class="header_page">
      <p id="title_header_page">صنف ها</p>
      <img id="arrow_back_page" src="@/assets/imgs/back.svg" alt="" @click="$router.go(-1)">
    </div>
    <div class="p-3" id="items-container">
      <div v-if="loading" class="d-flex justify-content-center mt-5">
        <p>در حال دریافت معلومات...</p>
      </div>
      
      <div v-else-if="errorMessage" class="d-flex justify-content-center mt-5 text-center">
        <p class="text_color_red bold">{{ errorMessage }}</p>
      </div>

      <div v-else>
        <div v-for="(course, index) in courses" :key="index" class="d-flex align-items-center gap-3 mb-3 item" @click="goToLessons(course.lesson_id)">
          <div class="position-relative">
            <p class="p-3 rounded-pill bg_light_theme"></p>
            <p class="hr_vertical"></p>
          </div>
          <div class="bg_white rounded-4 d-flex align-items-center justify-content-between p-3 shadow_box w-95">
            <div>
              <div class="d-flex align-items-center gap-3">
                <p>{{ course.title }}</p>
                <p class="text_color_gray">{{ course.count }} مضمون</p>
              </div>
              <div class="text_color_gray">{{ course.teacher }}</div>
            </div>
            <img src="@/assets/imgs/bg_arrow.svg" class="icon-size-4" alt="">
          </div>
        </div>
        <div v-if="courses.length === 0" class="text-center mt-4 text_color_gray">
          مضمونی برای این صنف یافت نشد.
        </div>
      </div>
    </div>

    <div v-if="showAccessModal" class="modal_overlay">
      <div class="modal_content">
        <div class="d-flex justify-content-center mb-3 position-relative">
           <div class="icon_circle_warning">
             <img src="@/assets/imgs/lock.svg" class="modal_img" alt="">
           </div>
        </div>
        <p class="text-center font_normal mb-5 line_height_2 px-2 mt-4">{{ accessMessage }}</p>
        <button class="modal_btn" @click="closeAccessModal">{{ accessBtnText }}</button>
      </div>
    </div>
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'

export default {
  name: 'GradeCoursesView',
  data() {
    return {
      courses: [],
      loading: false,
      errorMessage: '',
      showAccessModal: false,
      accessMessage: '',
      accessBtnText: ''
    }
  },
  mounted() {
    this.fetchCourses()
  },
  watch: {
    '$route.params.gradeId': function(newId) {
      if (newId) {
        this.fetchCourses()
      }
    }
  },
  methods: {
    async fetchCourses() {
      let gradeId = this.$route.params.gradeId
      if (gradeId) {
        gradeId = String(gradeId).trim()
      } else {
        return
      }

      let userId = localStorage.getItem('user_id')
      if (userId) {
        userId = String(userId).trim()
      }

      this.loading = true
      this.errorMessage = ''
      this.courses = []

      try {
        const formData = createFormData({
          grade_id: gradeId,
          user_id: userId
        })

        const response = await apiClient.post('/grades_lessons', formData)

        if (response.data.status === 'ok' && response.data.data) {
          this.courses = response.data.data
        }
      } catch (error) {
        if (error.response && error.response.status === 422) {
          const lang = localStorage.getItem('app_lang')
          
          if (lang === 'ps') {
            this.accessMessage = 'د دې تعلیمي درجې لاسرسی ستاسو لپاره امکان نلري'
            this.accessBtnText = 'پوه شوم'
          } else {
            this.accessMessage = 'دسترسی به این صنف تعلیمی برای شما مقدور نیست'
            this.accessBtnText = 'فهمیدم'
          }
          
          this.showAccessModal = true
        } else {
          this.errorMessage = 'مشکل در برقراری ارتباط با سرور'
        }
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    goToLessons(lessonId) {
      this.$router.push({ name: 'CourseLessons', params: { lessonId: lessonId } })
    },
    closeAccessModal() {
      this.showAccessModal = false
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.hr_vertical {
  width: 1px;
  height: 7rem;
  position: absolute;
  border: 1px dashed var(--bg_light_theme);
  left: 50%;
  transform: translate(-50%, -0.9rem);
}
.item:not(:last-child) .hr_vertical {
  display: block;
}
.item:last-child .hr_vertical,
.item:only-child .hr_vertical {
  display: none;
}
.modal_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal_content {
  background-color: white;
  width: 85%;
  max-width: 25rem;
  border-radius: 2.5rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  animation: fadeIn 0.3s ease-out;
}
.icon_circle_warning {
  background-color: #FFF9C4; 
  border-radius: 50%;
  padding: 1rem;
  width: 7rem;
  height: 7rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -4rem;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  border: 4px solid white;
}
.modal_img {
  width: 3.5rem;
  height: 3.5rem;
}
.modal_btn {
  background: linear-gradient(90deg, #8E2DE2 0%, #4A00E0 100%);
  color: white;
  border: none;
  border-radius: 50px;
  padding: 1rem 0;
  font-weight: bold;
  font-size: 1.1rem;
  box-shadow: 0 5px 15px rgba(74, 0, 224, 0.4);
  cursor: pointer;
  width: 100%;
  transition: transform 0.2s;
}
.modal_btn:active {
  transform: scale(0.98);
}
.line_height_2 {
  line-height: 2rem;
}
@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.9); }
  to { opacity: 1; transform: scale(1); }
}
</style>